import React from "react";
import {connect} from "react-redux";
import List from '../../../components/CRM/List';
import {
  Datagrid,
  TextField,
  refreshView as refreshViewAction
} from "admin-on-rest";
import ActionBar from "../../../components/CRM/ActionBar/";
import ActionMenu from "../../../components/CRM/ActionMenu";

class RegionDataList extends React.Component {
  render() {
    const props = {...this.props};

    return (
      <List
        title="resources.regions.name"
        {...props}
        actions={<ActionBar {...props} deleteButton={false} createButton={true} />}
        //filters={<DeviceFilter />} todo
      >
        <Datagrid>
          <TextField
            label="resources.regions.fields.name"
            source="name"
          />
          <ActionMenu
            deleteButton={false}
            showButton={false}
            editButton={true}
          />
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = state => {
  return {
    record: state.admin.resources.regions.data
  };
};

export default connect(
  mapStateToProps,
  {
    refreshView: refreshViewAction
  }
)(RegionDataList);



// WEBPACK FOOTER //
// ./src/containers/CRM/Regions/RegionDataList.js